// ============================================
// MAIN FORM PAGE - Multi-step Container
// ============================================

import { useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from '../../components/layout';
import { ProgressSteps } from '../../components/ui';
import { useFormStore, useAuthStore } from '../../store';
import { FORM_STEPS, ROUTES } from '../../constants';
import {
  PersonalDetailsStep,
  CurrentSetupStep,
  UsageDetailsStep,
  TechnicalPreferencesStep,
  FuturePlansStep,
  ReviewStep,
} from './steps';
import styles from './FormPage.module.css';

export function FormPage() {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuthStore();
  const { currentStep, formData, updatePersonalDetails, goToStep } = useFormStore();


  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, [currentStep]);

  // Redirect if not authenticated
  useEffect(() => {
    if (!isAuthenticated) {
      // setToast('Session expired. Please log in again.');
      setTimeout(() => navigate(ROUTES.LOGIN), 1500);
    }
  }, [isAuthenticated, navigate]);

  // Pre-fill email from auth
  useEffect(() => {
    if (user?.email && !formData.personalDetails.email) {
      updatePersonalDetails({ email: user.email });
    }
  }, [user?.email, formData.personalDetails.email, updatePersonalDetails]);

  const handleStepClick = (step: number) => {
    if (step < currentStep) {
      goToStep(step);
    }
  };

  let StepComponent;
  switch (currentStep) {
    case 1:
      StepComponent = <PersonalDetailsStep />;
      break;
    case 2:
      StepComponent = <CurrentSetupStep />;
      break;
    case 3:
      StepComponent = <UsageDetailsStep />;
      break;
    case 4:
      StepComponent = <TechnicalPreferencesStep />;
      break;
    case 5:
      StepComponent = <FuturePlansStep />;
      break;
    case 6:
      StepComponent = <ReviewStep />;
      break;
    default:
      StepComponent = <PersonalDetailsStep />;
  }

  return (
    <Layout maxWidth="md">

      <div className={styles.container}>
        <ProgressSteps
          steps={FORM_STEPS.map(s => ({ id: s.id, title: s.title, description: s.description }))}
          currentStep={currentStep}
          onStepClick={handleStepClick}
        />
        <div className={styles.stepContent}>
          {StepComponent}
        </div>
      </div>
    </Layout>
  );
}
